import React, { Fragment, useState } from 'react'
import { css } from "@emotion/react"
import HashLoader from "react-spinners/HashLoader"

const SpinnerLoading = (
    {
        loading,
        size,
        color
    }
) => {

    const override = css` display: block; margin: 0 auto; text-align: center;`

    const styles = {
        tr: {
            border: 'none',
        },
        text: {
            textAlign: "center",
            paddingTop: "60px",
            fontSize: "22px",
        }
    }

    return (
        <Fragment>
            <tr style={styles.tr}>
                <td style={styles.text} colSpan="100%">
                    <HashLoader  color={color} loading={loading} css={override} size={size} />
                </td>
            </tr>
        </Fragment>
    )
}

export default SpinnerLoading